import { useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import Hero from './components/Hero';
import CategoryBrowser from './components/CategoryBrowser';
import Featured from './components/Featured';
import Guides from './components/Guides';
import Articles from './components/Articles';
import Faq from './components/Faq';
import Cta from './components/Cta';
import { validLangs } from '@/mocks/languages';

export default function Home() {
  const { lang } = useParams();
  const { i18n } = useTranslation();
  const currentLang = lang && validLangs.includes(lang) ? lang : 'en';

  useEffect(() => {
    if (i18n.language !== currentLang) {
      i18n.changeLanguage(currentLang);
    }
  }, [currentLang, i18n]);

  return (
    <div className="min-h-screen flex flex-col bg-background-50">
      <Navbar />
      <main className="flex-1">
        <Hero />
        <CategoryBrowser />
        <Featured />
        <Guides />
        <Articles />
        <Faq />
        <Cta />
      </main>
      <Footer />
    </div>
  );
}